// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2cDrK","title":"ClientReferral_title__3dJVB","itemText":"ClientReferral_itemText__3v0z5"};